export * from './components/AnalyticsPageview'
export { AnalyticsBootstrap } from './components/AnalyticsBootstrap'
export { toGtmUserTraits } from './utils/gtmMiddleware'
export type { GtmUserTraits } from './utils/gtmMiddleware'
export { useAnalytics } from './hooks/useAnalytics'
export {
  AnalyticsProvider,
  useAnalyticsContext,
  useAnalyticsContextSafe,
  type AnalyticsProduct,
} from './providers/AnalyticsProvider'
export { getEventByAnalyticsId } from './utils/eventLookup'
export {
  getPageConfig,
  getCurrentPageType,
  type PageConfig,
  type PageType,
} from './config/pageConfig'
export { events } from './config/events'
export {
  MTAG_EVENTS,
  SOURCE_APP,
  ITEM_LOCATION_CONTEXT,
  type MtagEventName,
  type ItemLocationContext,
} from './config/eventNames'
export { omitEmpty } from './utils/omitEmpty'
export {
  CONSTRUCTOR_POD_IDS,
  constructorTrackingAttributes,
  constructorProductDetailAttributes,
  constructorRecommendationListAttributes,
  constructorRecommendationItemAttributes,
  setConstructorBeaconUserId,
  clearConstructorBeaconUserId,
  type ConstructorTrackingAttributes,
} from './utils/constructorBeacon'
export { trackBeforeNavigating } from './utils/trackBeforeNavigating'
export { useNavigationLatch } from './hooks/useNavigationLatch'
export { useModalImpression, type ImpressionExtra } from './hooks/useImpression'
export {
  useProductListViewed,
  productListItemAttributes,
  type ProductListViewedProduct,
} from './hooks/useProductListViewed'
export {
  useProductListFiltered,
  buildProductUrl,
  type ProductListFilteredProduct,
} from './hooks/useProductListFiltered'
export {
  impressions,
  getImpressionById,
  type ImpressionId,
} from './config/impressions'

// Canonical event types, generated from Material-Bank/AnalyticsInstrumentation.
// Re-exported so feature packages consume them via @material-bank/mtag-analytics without
// each taking a direct dependency on the generated package. Types only: the runtime
// schemas (and the zod build behind them) live on '@material-bank/mtag-analytics/schemas'.
export type * from '@material-bank/analytics-events-ts/mtag'
